import React from 'react';
import { Select, Option } from '@blueprint/ui';
import styled from 'styled-components';
import './NativeDropdown.css';

export const NativeDropdown = ({
    id,
    invalid,
    required,
    value,
    onChange,
    options,
    autoFocus = false,
    disabled,
    width,
    selectSize,
    defaultDisabled = false,
    className,
    ariaLabelledby,
    ariaDescribedby,
    ...rest
}) => {
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    return (
            <Select
                aria-labelledby={ariaLabelledby}
                id={id}
                value={value}
                onChange={(event) => {
                    const SelectedOption = {
                        // label: event.target.selectedOptions[0].label,
                        label: event.target.value,
                        value: event.target.value,
                    };
                    console.log('Logging from Native dropdown, Selected option is ', SelectedOption);

                    onChange(SelectedOption);
                }}
                invalid={invalid}
                required={required}
                autoFocus={autoFocus}
                disabled={disabled}
                width={width}
                selectSize={selectSize}
                className={className}
                aria-describedby={ariaDescribedby}
            >
                <Option disabled={defaultDisabled} selected value=''>
                    Select
                </Option>
                {options.map((option) => (
                    <Option value={option.value} data-label={option.label}>
                        {option.label}
                    </Option>
                ))}
            </Select>
    );
};
